import { render, staticRenderFns } from "./TastingPhotos.vue?vue&type=template&id=b1f7d4aa&scoped=true"
import script from "./TastingPhotos.vue?vue&type=script&lang=js"
export * from "./TastingPhotos.vue?vue&type=script&lang=js"
import style0 from "./TastingPhotos.vue?vue&type=style&index=0&id=b1f7d4aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f7d4aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f7d4aa')) {
      api.createRecord('b1f7d4aa', component.options)
    } else {
      api.reload('b1f7d4aa', component.options)
    }
    module.hot.accept("./TastingPhotos.vue?vue&type=template&id=b1f7d4aa&scoped=true", function () {
      api.rerender('b1f7d4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/TastingPhotos.vue"
export default component.exports